// extracted by mini-css-extract-plugin
export default {"container":"_34toj8DIAooqH9vtKEYrQw","content":"_1DIsQWCTrS0hVDM4OjEsnp","brand":"_2_74yLdQb5109Xs9_wLKDl","menu":"_3Z-ElDejqgFQmtukmv40cI","aux":"_2T170Q5xHJlUrfGJZxmttd"};